export function contactsScrollPosition(doc:Pick<Document,'querySelector'>=document,win:Pick<Window,'scrollY'>=window):number {
  return doc.querySelector('main')?.scrollTop ?? win.scrollY;
}
export function restoreContactsScroll(top:number,doc:Pick<Document,'querySelector'>=document,win:Pick<Window,'scrollTo'>=window):void {
  const main=doc.querySelector('main');
  if(main)main.scrollTop=top;else win.scrollTo(0,top);
}
